module.exports = __webpack_public_path__ + "img/success.477e28af.png";